import type { ITeamMember } from '~/types/teamMember/models'
import type { TEntityId } from '~/types/models'

/**
 * Decide whether refreshLoggedInTeamMember should re-fetch the team member.
 *
 * Extracted from store/loggedInUser.js so the decision is unit-testable now and
 * reusable unchanged by the Pinia store after the Nuxt 3 migration.
 *
 *   no logged-in user id -> throws (caller treats this as "never happens")
 *   ids match            -> true  (a refresh is warranted)
 *   ids differ           -> false (already loaded a different member; skip)
 *   no loaded team member -> false (not a team-member user; nothing of mine to
 *                            refresh — the changed team member can't be ours)
 */
export function shouldRefreshLoggedInTeamMember(o: {
  loggedInUserId: TEntityId | undefined
  loggedInTeamMember: ITeamMember | undefined
  requestedTeamMemberId: TEntityId
}): boolean {
  const fn = `[cynqueModules/store/shouldRefreshLoggedInTeamMember] |`
  if (!o.loggedInUserId) {
    throw new Error(
      `${fn} there is no loggedInUser, so can't refresh loggedInTeamMember.` +
        ` This should never happen.`
    )
  }
  return o.loggedInTeamMember?.id === o.requestedTeamMemberId
}
